import { addGroups, removeGroups } from '@/redux/util/kudos.util';

import {
	SET_KUDOS_BADGES,
	CREATE_KUDO_BADGE,
	UPDATE_KUDO_BADGE,
	DELETE_KUDO_BADGE,
	ADD_GROUPS_TO_KUDO_BADGE,
	REMOVE_GROUPS_FROM_KUDO_BADGE,
	CLEAR_KUDO_BADGES,
} from '../actions/actionTypes';

const preState = [];

export const kudosReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = [...state];
	const { type, kudoOrBadges, kudoBadge, kudoBadgeID, groupIDs } = action;

	switch (type) {
		case SET_KUDOS_BADGES:
			return [...kudoOrBadges];
		case CLEAR_KUDO_BADGES:
			return [];
		case CREATE_KUDO_BADGE:
			return [...stateDup, kudoBadge];
		case UPDATE_KUDO_BADGE:
			const { id } = kudoBadge;
			const updatedList = stateDup.map(kudo => (id === kudo.id ? { ...kudo, ...kudoBadge } : kudo));
			return updatedList;
		case DELETE_KUDO_BADGE:
			const removedKudoList = stateDup.filter(kudo => kudoBadgeID !== kudo.id);
			return removedKudoList;
		case ADD_GROUPS_TO_KUDO_BADGE:
			return stateDup.map(kudo => {
				if (kudo.id !== kudoBadgeID) return kudo;
				else return addGroups(groupIDs, kudo);
			});
		case REMOVE_GROUPS_FROM_KUDO_BADGE:
			return stateDup.map(kudo => {
				if (kudo.id !== kudoBadgeID) return kudo;
				else return removeGroups(groupIDs, kudo);
			});
		default:
			return state;
	}
};

export default kudosReducer;
